import { render, staticRenderFns } from "./VolunteerAvatar.vue?vue&type=template&id=64dbd00f&scoped=true"
import script from "./VolunteerAvatar.vue?vue&type=script&lang=js"
export * from "./VolunteerAvatar.vue?vue&type=script&lang=js"
import style0 from "./VolunteerAvatar.vue?vue&type=style&index=0&id=64dbd00f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dbd00f",
  null
  
)

export default component.exports